'use strict';
const angular = require('angular');
const {isObject, isUndefined} = angular;

import {DefaultRelationProperties} from './domain-properties/Properties';

export const AbstractRelationClassImport = [
  '$log',
  '$q',
  '$cacheFactory',
  'FirebaseObjectFactory',
  'FirebaseUtil',
  'DomainClassHelper',
  'DomainBootstrapper',
  '$domain',
  '$domainCache',
  'AbstractDomainClass',
  function (
    $log,
    $q,
    $cacheFactory,
    FirebaseObjectFactory,
    FirebaseUtil,
    DomainClassHelper,
    DomainBootstrapper,
    $domain,
    $domainCache,
    AbstractDomainClass,
  ) {
    function AbstractRelationClass(Class, data) {
      if (!Class) return; // only applicable to instantiations

      Object.defineProperties(this, new DefaultRelationProperties(this, {$class: Class}));

      for (var field in Class.$constraints) {
        if (Class.$constraints.hasOwnProperty(field)) {
          this.$$values.$defineValue(field, Class.$constraints[field]);

          Object.defineProperty(this, field, {
            enumerable: this.$$values[field].isEnumerable(),
            get: this.$$values[field].defineGetter(),
            set: this.$$values[field].defineSetter()
          });

          if (!data) {
            this[field] = this.$getDefaultValue(field);
          }
        }
      }

      if (isObject(data)) {
        this.$$values.$hydrate(data);
      }
    }


    //************************************************************************************************************
    // Static Methods
    //************************************************************************************************************

    AbstractRelationClass.createFactory = function (Class) {
      Object.defineProperty(Class, '$factory', {value: {}});
      //Object.defineProperty(Class.$factory, 'className', {value: Class.name});

      var cache = $cacheFactory.get(Class.$name) || $cacheFactory(Class.$name);

      Class.$factory.create = function (data) {
        var instance;
        var id = data ? data.$id : null;
        var collectionId = data ? data.$collectionId : null;
        var compositeId = id && collectionId ? id + collectionId : null;
        if (compositeId && (instance = cache.get(compositeId))) {
          return instance;
        } else if (compositeId) {
          instance = new Class(data);
          cache.put(compositeId, instance);
          return instance;
        } else {
          return new Class(data);
        }
      };
    };

    // TODO: implement destroy method to remove from cache and unbind any active firebase watchers
    AbstractRelationClass.prototype.$destroy = function $destroy() {
      //var cache = $cacheFactory.get(Class.name) || $cacheFactory(Class.name);
      //var id = data ? data.$id : null;
      //var collectionId = data ? data.$collectionId : null;
      //var compositeId = id && collectionId ? id + collectionId : null;
      //cache.remove(compositeId);
      //$domainCache.remove(this.$class.COLLECTION, this.$id);
      //
      //if (this.$$listener && this.$$listener.destroy) {
      //  console.log('AbstractRelationClass.prototype.$destroy FirebaseListener', this.$class.COLLECTION, this.$id);
      //  this.$$listener.destroy();
      //}
    };

    // Firebase Methods

    AbstractRelationClass.$get = function (id, collectionId, collectionName, linkCollectionName) {
      var self = this;
      var path = $domain.relationPath(collectionName, collectionId, linkCollectionName, id);
      return FirebaseUtil.read(path).then(
        function (data) {
          var ref = FirebaseUtil.firebaseRef(path);
          if (data === null || isUndefined(data)) {
            return null;
          } else {
            data.$id = id;
            data.$collectionId = collectionId;
            data.$collectionName = collectionName;
            data.$linkCollectionName = linkCollectionName;
            var instance = self.$factory.create(data);

            if (!instance.$ref) {
              instance.$ref = function () {
                return ref;
              };
            }

            return instance;
          }
        }
      );
    };

    AbstractRelationClass.$list = function (id, collectionId, collectionName, linkCollectionName, params) {
      //var q = $q.defer();

      //var user = AuthService.getUser();

      var config = {
        path: $domain.relationPath(collectionName, collectionId, linkCollectionName),
        factory: this.$factory,
        factoryMethodName: 'create'
      };

      if (params && params.filter) {
        config.filters = [params.filter];
      } else if (params && params.filters) {
        config.filters = params.filters;
      }

      return new FirebaseObjectFactory(config);

      //return q.promise;
    };

    AbstractRelationClass.$remove = function (id, collectionId, collectionName, linkCollectionName) {
      return FirebaseUtil.remove(AbstractRelationClass.$path(collectionName, collectionId, linkCollectionName, id));
    };


    //************************************************************************************************************
    // Prototype Methods
    //************************************************************************************************************

    AbstractRelationClass.prototype.constructor = AbstractRelationClass;


    //************************************************************************************************************
    //        Primary Methods
    //************************************************************************************************************

    AbstractRelationClass.prototype.$save = function (argsMap) {
      var self = this;
      argsMap = isObject(argsMap) ? argsMap : {};
      return this.$loaded().then(function () {
        var q = $q.defer();

        self.$$values.$updateAccountingValues();

        self.$validate();

        //console.log('saving to collection ' + self.COLLECTION);

        if (self.$hasErrors()) {
          //$timeout(function () {
          q.reject(self.$errors);
          //});
        } else {
          // serialize data

          DomainClassHelper.beforeSave(self, argsMap).then(function () {
            var serializedData = self.$serialize();
            return FirebaseUtil.update($domain.relationPath(self.$collectionName, self.$collectionId, self.$linkCollectionName, self.$id), serializedData)
              .then(function () {
                q.resolve();
              });
          }).then(function () {
            return DomainClassHelper.afterSave(self, argsMap);
          });
        }

        return q.promise;
      })
    };

    AbstractRelationClass.prototype.$serialize = AbstractDomainClass.prototype.$serialize;

    AbstractRelationClass.prototype.$delete = function (argsMap) {
      var self = this;
      var id = this.$id;
      var collectionId = this.$collectionId;
      var compositeId = id && collectionId ? id + collectionId : null;
      argsMap = isObject(argsMap) ? argsMap : {};
      return DomainClassHelper.beforeDelete(self, argsMap).then(function () {
        return FirebaseUtil.remove($domain.relationPath(self.$collectionName, self.$collectionId, self.$linkCollectionName, self.$id)).then(function () {
          return DomainClassHelper.afterDelete(self, argsMap).then(function () {
            $cacheFactory.get(self.$class.$name).remove(compositeId);
            $log.debug(self.$class.$name + '.$delete ' + id);
          });
        });
      });
    };

    AbstractRelationClass.prototype.$update = AbstractDomainClass.prototype.$update;
    AbstractRelationClass.prototype.$on = AbstractDomainClass.prototype.$on;
    AbstractRelationClass.prototype.$off = AbstractDomainClass.prototype.$off;
    AbstractRelationClass.prototype.$$notify = AbstractDomainClass.prototype.$$notify;

    AbstractRelationClass.prototype.$revert = AbstractDomainClass.prototype.$revert;

    AbstractRelationClass.prototype.$getOriginalValue = AbstractDomainClass.prototype.$getOriginalValue;

    // Links Methods

    AbstractRelationClass.prototype.$getLink = AbstractDomainClass.prototype.$getLink;

    AbstractRelationClass.prototype.$setLink = AbstractDomainClass.prototype.$setLink;

    AbstractRelationClass.prototype.$getDomainLink = AbstractDomainClass.prototype.$getDomainLink;

    AbstractRelationClass.prototype.$setDomainLink = AbstractDomainClass.prototype.$setDomainLink;

    // Validation

    AbstractRelationClass.prototype.$validate = AbstractDomainClass.prototype.$validate;

    AbstractRelationClass.prototype.$hasErrors = AbstractDomainClass.prototype.$hasErrors;


    //************************************************************************************************************
    //        Interceptors
    //************************************************************************************************************

    /**
     * Callback is invoked with the provided context (or null) immediately prior to saving, after validation has succeeded.
     * Callback is provided the following arguments:
     * instance: the object being saved.
     * save arguments map: the argument to the $save() method.
     *    Current implemented usage: when you save an instance of a linked collection, mapArgs.'list name' = relational data saved to firebase. defaults to true
     * args: an array of arguments passed as the second argument to $doBeforeSave
     *
     * @param callback
     * @param args
     * @param context
     */
    AbstractRelationClass.$doBeforeSave = DomainClassHelper.$doBeforeSave;

    /**
     * Callback is invoked with the provided context (or null) immediately after saving has succeeded.
     * Callback is provided the following arguments:
     * instance: the object being saved.
     * save arguments map: the argument to the $save() method.
     *    Current implemented usage: when you save an instance of a linked collection, mapArgs.'list name' = relational data saved to firebase. defaults to true
     * args: an array of arguments passed as the second argument to $doAfterSave
     *
     * @param callback
     * @param args
     * @param context
     */
    AbstractRelationClass.$doAfterSave = DomainClassHelper.$doAfterSave;

    /**
     * Callback is invoked with the provided context (or null) immediately prior to deletion
     * Callback is provided the following arguments:
     * instance: the object being deleted.
     * delete arguments map: the argument to the $delete() method.
     *
     * @param callback
     * @param args
     * @param context
     */
    AbstractRelationClass.$doBeforeDelete = DomainClassHelper.$doBeforeDelete;

    /**
     * Callback is invoked with the provided context (or null) immediately after deletion has succeeded.
     * Callback is provided the following arguments:
     * instance: the object being deleted.
     * delete arguments map: the argument to the $delete() method.
     *
     * @param callback
     * @param args
     * @param context
     */
    AbstractRelationClass.$doAfterDelete = DomainClassHelper.$doAfterDelete;


    //************************************************************************************************************
    // Builder Methods
    //************************************************************************************************************

    AbstractRelationClass.__inheritFrom = function (Class, className) {
      //console.log('Defining ' + className);
      Object.defineProperty(Class, "$constraints", {value: new $domain.Constraints(Class)});
      Object.defineProperty(Class, "$name", {value: className});
      Object.defineProperty(Class, "$$beforeSaveClosures", {value: []});
      Object.defineProperty(Class, "$$afterSaveClosures", {value: []});
      Object.defineProperty(Class, "$$beforeDeleteClosures", {value: []});
      Object.defineProperty(Class, "$$afterDeleteClosures", {value: []});

      Class.prototype = new AbstractRelationClass();
      Class.prototype.constructor = Class;
      Object.defineProperty(Class.prototype, "$constraints", {value: Class.$constraints});

      // inherit static methods here.
      Class.$get = AbstractRelationClass.$get;
      Class.$list = AbstractRelationClass.$list;
      Class.$remove = AbstractRelationClass.$remove;
      Class.$doBeforeSave = AbstractRelationClass.$doBeforeSave;
      Class.$doAfterSave = AbstractRelationClass.$doAfterSave;
      Class.$doBeforeDelete = AbstractRelationClass.$doBeforeDelete;
      Class.$doAfterDelete = AbstractRelationClass.$doAfterDelete;


      // generate the caching factory
      AbstractRelationClass.createFactory(Class);

      // force the dependency injector to define the class.
      DomainBootstrapper.queue(function (injector) {
        //console.log('Boostrapping ' + className);
        injector.get(className);
      });
    };

    return AbstractRelationClass;
  }];



// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/AbstractRelationClass.js